import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';

export function useRulesStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = useTheme();
  const iconColor = colorStyle.color.secondary;
  const radioTextColor = colorStyle.color.secondary;
  const subTitleColor = colorStyle.color.secondary;
  return { radioTextColor, iconColor, subTitleColor };
}
